export class ApiConfigCompany {
    "companyId": string = "";
    "displayName": string = "";
    "adminApiUrl": string = "";
    "bidNavUrl": string = "";
    "bidNavApiUrl": string = "";
    "bnKey": string = "";
    "currency": string = "$";
    "currencyCode": string = "USD";
    "defaultCountryCode": string = "us";
    "bases": string[] = [];
    "aircraft": string[] = [];
    "positions": string[] = [];
    "useStaticData": boolean = false;
    "bidNavVersion": BidNavVersion = BidNavVersion.Legacy
}

export enum BidNavVersion {
    Legacy = "Legacy",
    IE = "IE",
    UK = "UK",
    BidNav20 = "NG"
}